module.exports = __webpack_public_path__ + "img/permata-icon.2f9a085e.png";